import { render, staticRenderFns } from "./StageDistribution.vue?vue&type=template&id=ccfba3dc&scoped=true&"
import script from "./StageDistribution.vue?vue&type=script&lang=js&"
export * from "./StageDistribution.vue?vue&type=script&lang=js&"
import style0 from "./StageDistribution.vue?vue&type=style&index=0&id=ccfba3dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfba3dc",
  null
  
)

export default component.exports